import { watchSaveDetails } from './saveRecommendationDetailsSaga';
import { watchSaveRules } from './saveRecommendationRuleSaga';

const MerchandisingSagas = [watchSaveDetails(), watchSaveRules()];

export default MerchandisingSagas;
